export default __webpack_public_path__ + "static/media/icons8-innovation-100.638e2d42.svg";